import { Injectable } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TitleService {
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title
  ) {}

  init() {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          let child = this.activatedRoute.firstChild;
          while (child?.firstChild) {
            child = child.firstChild;
          }
          if (child?.snapshot.data['title']) {
            return child.snapshot.data['title'];
          }
          return 'LocalCenter'; // Título por defecto
        })
      )
      .subscribe((title: string) => {
        this.titleService.setTitle(title);
      });
  }

  // Método adicional para establecer título manualmente
  setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  // Método para obtener el título actual
  getTitle(): string {
    return this.titleService.getTitle();
  }
}